import * as React from "react";
import * as Utils from '../modules/metajson-sub/src/libs/helpers/Utils';
import { IOptions } from 'src/types/options'
import {FORM_STATUS, URL_PREFIX} from "../const/forms";
import {isUndefined} from 'util';

const host = process.env.NODE_ENV === 'production' ?`${window.location.origin}`: "http://localhost:3000";

export interface I18NString extends Utils.I18NString{}
export let tr = Utils.tr;
export const isNullOrEmpty = Utils.isNullOrEmpty;
export const breakLine = Utils.breakLine;
export const initLanguage = Utils.initLanguage;
export const getRandomKey = Utils.getRandomKey
export const sleep = Utils.sleep;
export const assign = Utils.assign;
export const goToAnchor = Utils.goToAnchor;
export const getFiletExtension = Utils.getFiletExtension;
export const checkFileExtension = Utils.checkFileExtension;
export class Guid extends Utils.Guid {}
export const clearNonNumberCharacters = Utils.clearNonNumberCharacters;
export const numberCommaToDot = Utils.numberCommaToDot;
export const numberDotToComma = Utils.numberDotToComma;
export const strCommaToDot = Utils.strCommaToDot;
export const parseFloatCommaDot = Utils.parseFloatCommaDot;
export const numberToFixedString = Utils.numberToFixedString;
export const roundCurrency = Utils.roundCurrency;
export const getCountRequiredInSection = Utils.getCountRequiredInSection;
export const getCountRequired = Utils.getCountRequired;
export const notify = Utils.notify;
export const confirm = Utils.confirm;
export abstract class Component<TProp, TState> extends Utils.Component<TProp, TState> {}
export class Session extends Utils.Session {}

export class ActionCreator<T, P> {
    readonly type: T;
    readonly payload: P;

    constructor(type: T) { this.type = type; }
    create = (payload: P) => ({ type: this.type, payload });
}

export function getConfig() : IOptions{
    return {
        process_id: 0,
        form_type: '',
        valuesId: Session.getSession(),
        apiUrl: `${host}${URL_PREFIX}/public/v1/forms`,
        filesUrl: `${host}${URL_PREFIX}/public/v1/forms/files`,
        apiUser: `${host}${URL_PREFIX}/public/v1/users`,
        companyUrl: `${host}${URL_PREFIX}/public/v1/company`,
        baseUrl: `${host}${URL_PREFIX}/public/v1`,
        token: "11",
    }
}

export function getProcessStatus(item){
    if(item.process_status){
        return item.process_status
    }else{
        if(item.process_completed){
            return 'Завершено'
        }
        return !isUndefined(FORM_STATUS[item.form_status]) ? FORM_STATUS[item.form_status] : 'Неизвестно';
    }
}


